import { EventClassification } from '../models/DeviceEvent';
import { 
    alertCircleOutline, 
    ellipsisHorizontalCircleOutline, 
    personCircleOutline, 
    phonePortraitOutline, 
    shieldCheckmarkOutline, 
    warningOutline 
} from 'ionicons/icons';

export function colorForEventClassification(eventClassification?: EventClassification | null) {
    return {
        [EventClassification.Unknown]: 'medium',
        [EventClassification.Clear]: 'success',
        [EventClassification.Suspicious]: 'warning',
        [EventClassification.Contraband]: 'danger',
        [EventClassification.HumanActivity]: 'primary',
        [EventClassification.RemoteUnlock]: 'secondary',
    }[eventClassification!] || 'medium';
}

export function iconForEventClassification(eventClassification?: EventClassification | null) {
    return {
        [EventClassification.Unknown]: ellipsisHorizontalCircleOutline,
        [EventClassification.Clear]: shieldCheckmarkOutline,
        [EventClassification.Suspicious]: alertCircleOutline,
        [EventClassification.Contraband]: warningOutline,
        [EventClassification.HumanActivity]: personCircleOutline,
        [EventClassification.RemoteUnlock]: phonePortraitOutline,
    }[eventClassification!] || ellipsisHorizontalCircleOutline;
}

export function labelForEventClassification(eventClassification: EventClassification | null | undefined, t: (key: string) => string) {
    return {
        [EventClassification.Unknown]: t('device_event_item.no_activity'),
        [EventClassification.Clear]: t('device_event_item.all_clear'),
        [EventClassification.Suspicious]: t('device_event_item.contraband_suspected'),
        [EventClassification.Contraband]: t('device_event_item.contraband_detected'),
        [EventClassification.HumanActivity]: t('device_event_item.human_activity'),
        [EventClassification.RemoteUnlock]: t('device_event_item.remote_unlock'),
    }[eventClassification!] || t('device_event_item.unknown');
}
